import { Request } from '@/classes/Request.ts'
import { Util } from '@/modules/util'
import type { UnpaidInvoice } from '@/types/familyUserInvoice'

// GET /ajax/invoice_headers/unpaid
export const unpaidInvoices = async () => {
  const response = await new Request().get('/ajax/invoice_headers/unpaid')
  return Util.Obj.keysToCamel(response.data.invoice_headers) as UnpaidInvoice[]
}
